import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'

export const Intro = styled.p`
  margin: 5.2rem auto 3rem;
  max-width: 68rem;
  text-align: center;
  line-height: 1.4;

  ${mq.medium} {
    font-size: 1.8rem;
  }
`

export const Section = styled.section`
  margin: 8rem 0;
`

const dividerStyles = css`
  border-bottom: 1px solid currentColor;

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 6rem;
    transform: translateY(-50%);
    border-left: 1px solid currentColor;
    border-right: 1px solid currentColor;
  }

  &::after {
    display: none;
  }
`

export const doubleDividerStyles = css`
  &::after {
    display: block;
    border-left-width: 0;
    width: 40%;
  }
`

export const SectionTitle = styled.h2`
  position: relative;
  padding: 0 0 2.5rem 2.5rem;
  font-size: 3.6rem;
  font-weight: 500;
  ${dividerStyles}

  ${mq.large} {
    ${doubleDividerStyles}
    padding-left: 52rem;
  }
`

export const Outro = styled.div`
  position: relative;
  padding-bottom: 12rem;
  margin-bottom: 10rem;
  text-align: center;
  font-size: 2rem;
  ${dividerStyles}

  p {
    margin: 0 auto 4rem;
    max-width: 55rem;
  }
`
